import Tappable from 'react-tappable'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import { numberToCurrency } from 'lib/money'

import { GreenCheckmarkIcon, RegistryIcon } from 'components/icons'

import Link from 'components/link'
import Image from 'components/image'
import * as blUrls from 'lib/urls'
import {
  GOALS,
  ADD_ARRIVAL_DATE,
  ADD_BABYLIST_BUTTON,
  ADD_FROM_BABYLIST_STORE,
  ADD_SHIPPING_ADDRESS,
  INSTALL_BABYLIST_APP,
  PURCHASE_FROM_BABYLIST_STORE,
  HELLO_BABY_BOX,
} from 'registry/constants'
import { CONFIG, DEVICE_PLATFORMS } from 'shared/constants'

import css from './hello-baby-box-status.scss'

const UnqualifiedBody = ({
  devicePlatform,
  qualificationGoals,
  setActiveModal,
}) => {
  const history = useHistory()
  const priceStr = numberToCurrency(CONFIG.registry.helloBabyBoxShippingPrice, {
    truncateZeroCents: true,
    unit: '$',
  })

  const handleGoalClick = (modalToOpen) => {
    setActiveModal(modalToOpen, {
      from: HELLO_BABY_BOX,
    })
  }

  const renderGoalComponent = ({
    id,
    isHelloBabyBoxQualified,
    hbbGoalText,
    hbbGoalIconFileName,
    hbbGoalIconAltText,
  }) => {
    let handleClick = null
    switch (id) {
      case GOALS.arrivalDate:
        handleClick = () => handleGoalClick(ADD_ARRIVAL_DATE)
        break
      case GOALS.shippingAddress:
        handleClick = () => handleGoalClick(ADD_SHIPPING_ADDRESS)
        break
      case GOALS.otherStoreItems:
        const modal =
          devicePlatform !== DEVICE_PLATFORMS.desktop
            ? INSTALL_BABYLIST_APP
            : ADD_BABYLIST_BUTTON
        handleClick = () => handleGoalClick(modal)
        break
      case GOALS.babylistStoreItems:
        handleClick = () => handleGoalClick(ADD_FROM_BABYLIST_STORE)
        break
      case GOALS.babylistStorePurchase:
        handleClick = () => handleGoalClick(PURCHASE_FROM_BABYLIST_STORE)
        break
      case GOALS.checklistFortyPercentComplete:
        handleClick = () => {
          setActiveModal(null)
          history.push(`${blUrls.registryChecklistPath}?fromHBB=true`)
        }
        break
      default:
        return null
    }

    if (!handleClick) {
      return null
    } else {
      const icon = (
        <RegistryIcon
          fileName={hbbGoalIconFileName}
          alt={hbbGoalIconAltText}
          className={css.modalGoalIcon}
        />
      )
      return (
        <Goal
          icon={icon}
          isComplete={isHelloBabyBoxQualified}
          onClick={handleClick}
          text={hbbGoalText}
        />
      )
    }
  }

  return (
    <>
      <div className="mhl-sm">
        <Image
          alt="Hello Baby Box"
          className="center-block img-responsive"
          src="//images.babylist.com/image/upload/f_auto,q_auto/v1568844195/bg-hbb_2x_oou5bf.png"
        />
      </div>
      <p className="mhl-sm mtl mbxl">
        The{' '}
        <Link url={blUrls.helloBabyBoxPostPath} newWindow>
          Hello Baby Box
        </Link>{' '}
        is filled with amazing samples and offers from coveted brands, and is
        our gift to Babylist registry users. To get a box, complete the steps
        below and pay for shipping ({priceStr}).
      </p>

      <ul className={classNames(css.goals, 'list-unstyled mbl')}>
        {qualificationGoals.map((goal, idx) => (
          <li key={goal.id}>{renderGoalComponent({ ...goal })}</li>
        ))}
      </ul>

      <p className="mhl-sm mtl">
        For more information,{' '}
        <Link newWindow url={blUrls.helloBabyBoxFaq}>
          visit our FAQs
        </Link>
        .
      </p>
    </>
  )
}

const Goal = ({ icon, isComplete, onClick, text }) => (
  <Tappable className={classNames(css.goal, 'phl pvm')} onClick={onClick}>
    {icon}
    <div className={classNames(css.goalText, 'phm')}>
      <div>{text}</div>
    </div>
    {isComplete ? (
      <GreenCheckmarkIcon className={css.completeIcon} />
    ) : (
      <span
        className={classNames(
          css.incompleteIcon,
          'fa fa-angle-right fa-2x phs text-muted'
        )}
      />
    )}
  </Tappable>
)

export default UnqualifiedBody
